import { render, staticRenderFns } from "./news15.vue?vue&type=template&id=14267974&"
import script from "./news15.vue?vue&type=script&lang=js&"
export * from "./news15.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports